import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { AppService } from 'src/app/_services/app-service/logic/app.service';
import { CredentialsService } from 'src/app/_services/credentials/logic/credentials.service';
import { ServiceRemoteActionBuilder } from '../service-remote-action-builder';

export class LogTerminalConnectionProblemRemoteActionBuilder extends ServiceRemoteActionBuilder {
  constructor(
    tourImsId: number,
    terminalId: String,
    terminalError: String,
    appService: AppService,
    credentialsService: CredentialsService,
    logger?: LoggingService,
  ) {
    super(
      appService,
      credentialsService,
      {
        endpoint: 'logterminalconnectionproblem',
        data: {
          tourimsid: tourImsId,
          terminal_id: terminalId,
          terminal_error: terminalError,
        },
        cachable: true,
        fifo: false,
        authenticationRequired: true,
        hideInDayProtocol: true,
      },
      [],
      async (_data: any) => {},
      logger,
    );
  }
}
